<template>
  <div class="collectBill">
    <el-collapse v-model="activeNames" class="collapse-main-content">
      <el-collapse-item name="1">
        <template slot="title">
          <div class="collapse-title-pre">
            <span></span>{{ this.$t('billDetail.collapseTitle.baseTitle') }}
          </div>
        </template>
        <div class="collapse-content">
          <BasicInfo
            :sysConfigFlag="sysConfigFlag"
            :canEdit="canEdit"
            :type="'collect'"
            :companyList="companyList"
            :fundPaymentBillFlag="fundPaymentBillFlag"
            @getDepartment="getDepartment"
            @getSysConfigByCompany="getSysConfigByCompany"
            @departmentChange="departmentChange"
            @customerChange="customerChange"
            @basicInfoChange="basicInfoChange"
            ref="basicInfo"
          />
        </div>
      </el-collapse-item>
      <el-collapse-item name="2">
        <template slot="title">
          <div class="collapse-title-pre">
            <span></span>{{ this.$t('billDetail.collapseTitle.billStatusTitle') }}
          </div>
        </template>
        <div class="collapse-content">
          <el-tabs
            type="border-card"
            v-model="activeNameTab"
            class="addCooperationTabs"
            @tab-click="handleClick"
          >
            <!--合同信息改为认领信息-->
            <el-tab-pane :label="$t('billDetail.tabTitle.contractTitle')" name="first">
              <contract-table
                ref="contract"
                :sysConfigFlag="sysConfigFlag"
                :canEdit="canEdit"
                :basicInfo="basicInfo"
                :initApportionAmount="initApportionAmount"
              ></contract-table>
            </el-tab-pane>
            <!--贴现信息-->
            <el-tab-pane :label="$t('billDetail.tabTitle.discountTitle')" name="discount">
              <discount-info
                ref="discount"
                :canEdit="canEdit"
                :isEdit="isEdit"
                :basicInfo="basicInfo"
                :departmentList="departmentList"
                :fundPaymentBillFlag="fundPaymentBillFlag"
              ></discount-info>
            </el-tab-pane>
            <!--背书信息-->
            <el-tab-pane :label="$t('billDetail.tabTitle.reciteTitle')" name="recite">
              <recite-info
                ref="recite"
                :canEdit="canEdit"
                :isEdit="isEdit"
                :fundPaymentBillFlag="fundPaymentBillFlag"
                :departmentList="departmentListAll"
              ></recite-info>
            </el-tab-pane>
            <!--托收信息-->
            <el-tab-pane :label="$t('billDetail.tabTitle.collectionTitle')" name="collection">
              <collection-info
                ref="collection"
                :canEdit="canEdit"
                :isEdit="isEdit"
                :fundPaymentBillFlag="fundPaymentBillFlag"
              ></collection-info>
            </el-tab-pane>
            <!--质押信息-->
            <el-tab-pane :label="$t('billDetail.tabTitle.pledgeTitle')" name="pledge">
              <pledge-info
                ref="pledge"
                :sysConfigFlag="sysConfigFlag"
                :canEdit="canEdit"
                :isEdit="isEdit"
                :companyList="companyList"
                :fundPaymentBillFlag="fundPaymentBillFlag"
              ></pledge-info>
            </el-tab-pane>
            <!--会计凭证-->
            <!-- <el-tab-pane
              :label="$t('billDetail.tabTitle.accountingVoucherTitle')"
              name="voucherTab"
            >
              <voucher
                ref="voucher"
                :voucherList="voucherList"
                @reverseInfo="reverseInfo"
                @postInfo="postInfo"
              ></voucher>
            </el-tab-pane> -->
          </el-tabs>
        </div>
      </el-collapse-item>
      <!--付款信息-->
      <el-collapse-item name="3" v-if="showPayInfo">
        <template slot="title">
          <div class="collapse-title-pre">
            <span></span>{{ this.$t('billDetail.collapseTitle.payInfoTitle') }}
          </div>
        </template>
        <div class="collapse-content">
          <pay-info-table ref="payInfoRef"></pay-info-table>
        </div>
      </el-collapse-item>
      <!--上传附件-->
      <el-collapse-item name="4">
        <template slot="title">
          <div class="collapse-title-pre">
            <span></span>{{ this.$t('billDetail.collapseTitle.collectBillTitle') }}
          </div>
        </template>
        <div class="collapse-content">
          <!-- <upload :isShow="canEdit" @upload="handleUpload" :tableData="fundAttachmentList || []" /> -->
          <FileTable
            ref="fileTableRef"
            :attachments="fundAttachmentList || []"
            :isShowDownBtn="!canEdit"
          />
        </div>
      </el-collapse-item>
    </el-collapse>
    <div class="fixed-bottom-btnList">
      <el-button
        v-if="this.$route.name.indexOf('Details') != -1"
        type="primary"
        @click="canEdit = !canEdit"
        :disabled="allDetail.billStatus == '07'"
        class="fixed-bottom-btn"
        v-hasPermi="['2021050810213093922']"
        >{{ this.$t('functionBtn.editToggle') }}</el-button
      >
      <el-button
        type="primary"
        :disabled="!canEdit"
        @click="save"
        class="fixed-bottom-btn"
        v-hasPermi="['2021050810221275516']"
        >{{ this.$t('billDetail.button.save') }}</el-button
      >
      <!-- 生成会计凭证 -->
      <el-button
        type="primary"
        :disabled="
          allDetail.billStatus == '' ||
          ['notgenerate', 'generated', 'postError'].indexOf(allDetail.accountingStatus) == -1
        "
        @click="handleAccountEntry"
        class="fixed-bottom-btn"
        v-hasPermi="['2021050810230251605']"
        >{{ this.$t('billDetail.button.makeAccountingVoucher') }}</el-button
      >
      <el-button
        :disabled="
          allDetail.billStatus == '' ||
          ['generated', 'postError'].indexOf(allDetail.accountingStatus) == -1
        "
        type="primary"
        @click="doSyncVoucherForEntityData()"
        class="fixed-bottom-btn"
        v-hasPermi="['2021050810232932589']"
        >{{ $t('functionBtn.doSyncVoucher') }}</el-button
      >
      <el-button
        :disabled="['01'].indexOf(allDetail.billStatus) == -1"
        type="primary"
        @click="doReverseAccountEntry"
        class="fixed-bottom-btn"
        v-hasPermi="['2021050810253076426']"
        >冲销</el-button
      >
    </div>
  </div>
</template>
<script>
  import { mapState } from 'vuex';
  import BasicInfo from '../components/basicInfo';
  import contractTable from '../components/contractTable';
  import discountInfo from '../components/discountInfo';
  import reciteInfo from '../components/reciteInfo';
  import payInfoTable from '../components/payInfoTable';
  import collectionInfo from '../components/collectionInfo';
  import pledgeInfo from '../components/pledgeInfo';
  import API from '@/api/capitalCenter/bill';
  import { dateFormatter } from '@/common/js/util';
  import voucherMixins from '@/common/mixins/voucher.js';
  import DataBaseAPI from '@/api/dataBase';

  export default {
    name: 'collectBill',
    mixins: [voucherMixins],
    components: {
      BasicInfo,
      contractTable,
      discountInfo,
      collectionInfo,
      reciteInfo,
      pledgeInfo,
      payInfoTable,
    },
    computed: {
      ...mapState({
        userInfo: (state) => state.userInfo.userInfo,
      }),
      showPayInfo() {
        if (this.$route.name.indexOf('Details') != -1) {
          return true;
        }
        return false;
      },
    },
    data() {
      return {
        canEdit: true,
        activeNames: ['1', '2', '3'],
        allDetail: { billStatus: null, isClaim: null },
        voucherList: [], //凭证列表
        isEdit: true,
        companyList: [],
        departmentList: [],
        departmentListAll: [],
        fundAttachmentList: [],
        componentsList: [
          {
            componentKey: 'contract',
            dataKey: 'fundBillContractList',
            type: 'table',
          }, // 合同
          {
            componentKey: 'pledge',
            dataKey: 'fundBillPledgeList',
            type: 'table',
          }, // 质押
          { componentKey: 'discount', dataKey: 'fundBillDiscount', type: 'form' }, // 贴现
          { componentKey: 'recite', dataKey: 'fundBillEndorse', type: 'form' }, // 背书
          {
            componentKey: 'collection',
            dataKey: 'fundBillCollection',
            type: 'form',
          }, // 托收
        ],
        voucherFlag: 'AE_AR_BILL', //凭证标识
        sysConfigFlag: null, // 系统配置标识 海宁：Y
        basicInfo: {},
        fundPaymentBillFlag: null, //是否被付款单引用，为“1”时代表已被付款单引用
        initApportionAmount: '',
      };
    },
    mounted() {
      if (this.$route.name.indexOf('Details') != -1) {
        this.canEdit = false;
      }
      this.getCompany();
      this.getDepartmentAll();
      let id = this.$route.query.copyId ? this.$route.query.copyId : this.$route.query.id;
      if (id) {
        this.getData(id);
      }
    },
    methods: {
      async getSysConfigByCompany(companyCode) {
        // 系统配置判断
        let contract = this.$refs.contract;
        let contractTable = contract.$refs.contractTable.getTableData().fullData;
        let addRowObj = contract.addRowObj;
        [
          'customerNo',
          'customerName',
          'customerType',
          'contractBusinessDepartmentNo',
          'contractBusinessDepartmentName',
        ].map((i) => {
          return (addRowObj[i] = '');
        });
        contractTable.map((item) => {
          [
            'contractNo',
            'externalContractNo',
            'customerNo',
            'customerName',
            'customerType',
            'contractSalesmanNo',
            'contractSalesmanName',
            'contractBusinessDepartmentNo',
            'contractBusinessDepartmentName',
          ].map((i) => {
            return (item[i] = '');
          });
          //item.discountInterestAmount = "";
          item.receivedType = '';
        });
        let res = await this.$baseRequest.getSysConfigByCompany({
          code: 'BILL_YS_HN',
          companyCode,
        });
        if (res) {
          this.sysConfigFlag = res;
          let basicInfo = this.$refs.basicInfo.baseData;
          if (res == 'Y') {
            basicInfo.discountType = '';
          } else {
            basicInfo.preEndorseeName = '';
            contractTable.map((item) => {
              //item.discountInterestAmount = "";
              item.receivedType = '';
            });
          }
        }
      },
      departmentChange(val) {
        let contract = this.$refs.contract;
        let contractTable = contract.$refs.contractTable.getTableData().fullData;
        let addRowObj = contract.addRowObj;
        addRowObj.customerNo = addRowObj.customerName = addRowObj.customerType = '';
        addRowObj.contractBusinessDepartmentName = val.departmentName;
        addRowObj.contractBusinessDepartmentNo = val.departmentNo;
        contractTable.map((item) => {
          [
            'contractNo',
            'externalContractNo',
            'customerNo',
            'customerName',
            'customerType',
            'contractSalesmanNo',
            'contractSalesmanName',
          ].map((i) => {
            return (item[i] = '');
          });
          item.contractBusinessDepartmentName = val.departmentName;
          item.contractBusinessDepartmentNo = val.departmentNo;
        });
      },
      customerChange(val) {
        let contract = this.$refs.contract;
        let contractTable = contract.$refs.contractTable.getTableData().fullData;
        let addRowObj = contract.addRowObj;
        addRowObj.customerNo = val.customerNo;
        addRowObj.customerName = val.customerName;
        addRowObj.customerType = val.customerType;
        contractTable.map((item) => {
          item.contractNo =
            item.externalContractNo =
            item.contractSalesmanNo =
            item.contractSalesmanName =
              '';
          item.customerNo = val.customerNo;
          item.customerName = val.customerName;
          item.customerType = val.customerType;
        });
      },
      basicInfoChange(info) {
        this.basicInfo = info;
        this.initApportionAmount = info.billAmount;
      },
      importDetail(allDetail) {
        if (allDetail.billStatus == '07') {
          this.canEdit = false;
        }
        this.allDetail = allDetail;
        this.fundPaymentBillFlag = allDetail.fundPaymentBillFlag;
        this.sysConfigFlag = allDetail.isHnFlag;
        // 基本信息
        let basicInfo = this.$refs.basicInfo.baseData;
        Object.keys(basicInfo).map((item) => {
          if (item.indexOf('is') == 0) {
            return (basicInfo[item] = allDetail[item] == '1' ? true : false);
          } else {
            return (basicInfo[item] = allDetail[item]);
          }
        });
        this.$refs.basicInfo.getDepartment(basicInfo.billCompanyCode);
        if (this.$route.query.copyId) {
          // 复制时，勾选是否复制，清空应收票据号
          basicInfo.id = null;
          basicInfo.copyBillCode = allDetail.billCode;
          basicInfo.copyBillTakeDepartmentName = allDetail.billTakeDepartmentName;
          basicInfo.billCode = null;
          basicInfo.billSerialNumber = null;
          basicInfo.isCopy = true;
          basicInfo.billRecorderNo = this.userInfo.userCode;
          basicInfo.billRecorderName = this.userInfo.userName;
          basicInfo.billRecordDate = dateFormatter(new Date());
        }
        this.basicInfo = basicInfo;
        this.componentsList.map((item) => {
          if (item.type == 'table') {
            this.getTableData(item.componentKey, allDetail[item.dataKey]);
          } else {
            this.getFormData(item.componentKey, allDetail[item.dataKey]);
          }
        });
        let addRowObj = this.$refs.contract.addRowObj;
        addRowObj.customerNo = allDetail.customerNo;
        addRowObj.customerName = allDetail.customerName;
        addRowObj.customerType = allDetail.customerType;
        addRowObj.contractBusinessDepartmentName = allDetail.billTakeDepartmentName;
        addRowObj.contractBusinessDepartmentNo = allDetail.billTakeDepartmentNo;
        this.fundAttachmentList = allDetail.returnAttachmentList; // 附件
        // 获取凭证ID 获取凭证列表
        this.entityDataId = allDetail.id;
        this.getAccountEntry();
        this.$refs.payInfoRef.getData(allDetail.billCode);
      },
      async getData(
        id = this.$route.query.copyId ? this.$route.query.copyId : this.$route.query.id
      ) {
        if (!id) id = this.entityDataId;
        // 获取详情数据
        this.loading.startLoading();
        let res = await this.$axios.get(API.QUERY_FUNDBILL_BY_ID, { id });
        if (res) {
          this.loading.endLoading();
          if (res.data.code == 0) {
            this.importDetail(res.data.data);
          }
        }
      },
      getTableData(name, returnData) {
        if (returnData) {
          this.$refs[name].tableData = returnData;
        } else {
          this.$refs[name].tableData = [];
        }
        // 复制时，清空id
        if (this.$route.query.copyId) {
          this.$refs[name].tableData.map((item) => {
            item.id = null;
          });
        }
      },
      getFormData(name, returnData) {
        let data = this.$refs[name].baseData;
        if (returnData) {
          Object.keys(data).map((item) => {
            return (data[item] = returnData[item]);
          });
        }
        // 复制时，清空id
        if (this.$route.query.copyId) {
          data.id = null;
        }
      },
      async getCompany() {
        // 公司
        let params = {
          id: this.userInfo.userCode,
          userCode: this.userInfo.userCode,
          personName: this.userInfo.userName,
        };
        const selectStatus = await this.$axios.post(DataBaseAPI.GET_PERSON_API, params);
        if (selectStatus.data.code == 0) {
          this.companyList = selectStatus.data.data.personCompanyInfo.map((item) => {
            return {
              value: item.personCompanyCode,
              label: item.personCompanyName,
            };
          });
        }
      },
      // 部门（本人权限）
      getDepartment(val) {
        this.departmentList = val;
      },
      // 部门没有权限限制
      async getDepartmentAll() {
        const selectStatus = await this.$axios.post(
          DataBaseAPI.LIST_DEPARTMENT_API + '/' + this.userInfo.companyCode
        );
        if (selectStatus.data.code == 0) {
          this.departmentListAll = selectStatus.data.data;
          console.log(this.departmentListAll);
        }
      },
      // 贴现、背书、托收、质押三种状态互斥，不可能同时存在；
      mutex(type) {
        this.isEdit = true;
        let status = ['discount', 'recite', 'collection']; // 贴现、背书、托收、质押状态

        status.forEach((item) => {
          if (type != item) {
            let baseData = this.$refs[item].baseData;
            Object.keys(baseData).map((i) => {
              if (i != 'id' && baseData[i]) {
                return (this.isEdit = false);
              }
            });
          }
        });
        let tableData = this.$refs['pledge'].$refs.pledgeTable.getTableData().fullData;
        if (type != 'pledge' && this.allDetail.billStatus == '06' && tableData.length > 0) {
          return (this.isEdit = false);
        }
        // status.map((item) => {
        //   if (type != item) {
        //     let baseData = this.$refs[item].baseData;
        //     Object.keys(baseData).map((i) => {
        //       if (i != "id" && baseData[i]) {
        //         this.isEdit = false;
        //       }
        //     });
        //   }
        // });
      },
      handleClick(e) {
        this.mutex(e.name);
      },
      returnForm(formData) {
        let flag = false;
        Object.keys(formData).map((item) => {
          if (item != 'id' && formData[item]) {
            return (flag = true);
          }
        });
        return flag ? formData : null;
      },
      // 保存
      async save() {
        let basicInfo = this.$refs.basicInfo.exportChildData(); // 基本信息
        let fundBillContractList = await this.$refs.contract.exportChildData(); // 合同
        let fundBillDiscount = this.$refs.discount.exportChildData(); // 贴现
        let fundBillEndorse = this.$refs.recite.exportChildData(); // 背书
        let fundBillCollection = this.$refs.collection.exportChildData(); // 托收
        let fundBillPledgeList = await this.$refs.pledge.exportChildData(); // 质押
        if (
          basicInfo &&
          fundBillContractList &&
          fundBillDiscount &&
          fundBillEndorse &&
          fundBillCollection &&
          fundBillPledgeList
        ) {
          /* let discountFlag = false;
          Object.keys(fundBillDiscount).map((item) => {
            if (fundBillDiscount[item]) {
              return (discountFlag = true);
            }
          });
          if (discountFlag) {
            return this.tips('noDiscountType', 'error');
          } */
          if (fundBillContractList.length > 0) {
            let contractSum = 0;
            //let customerFlag = false;
            // let departmentFlag = false;
            fundBillContractList.map((item) => {
              contractSum = this.$cal.calCommon(item.apportionAmount, contractSum, '+');
              /* if (item.customerNo != basicInfo.customerNo) {
                customerFlag = true;
              } */
              // if (
              //   item.contractBusinessDepartmentNo !=
              //   basicInfo.billTakeDepartmentNo
              // ) {
              //   departmentFlag = true;
              // }
            });
            /* if (customerFlag) {
              return this.tips('verifyCustomer', 'error');
            }
            if (customerFlag) {
              return this.tips('verifyDepartment', 'error');
            } */
            if (contractSum != basicInfo.billAmount && basicInfo.isClaim == '1') {
              return this.tips('verifyAmountIsEqual', 'error');
            }
            if (contractSum > basicInfo.billAmount && basicInfo.isClaim == '0') {
              return this.tips('verifyAmount', 'error');
            }
          }
          let isPledge = fundBillPledgeList.length > 0 ? '1' : '0';
          let params = {
            billType: '1',
            isPledge,
            ...basicInfo,
            fundBillContractList,
            fundBillDiscount: this.returnForm(fundBillDiscount),
            fundBillEndorse: this.returnForm(fundBillEndorse),
            fundBillCollection: this.returnForm(fundBillCollection),
            fundBillPledgeList,
            fundAttachmentList: this.$refs.fileTableRef?.getTableData(),
          };
          if (this.$route.query.copyId) {
            params = {
              ...params,
              copyId: this.$route.query.copyId,
            };
          }
          params = this.$baseRequest.assignObj(params);
          this.loading.startLoading();
          let res = await this.$axios.post(API.SAVE_FUNDBILL, params);
          if (res) {
            this.loading.endLoading();
            if (res.data.code == 0) {
              this.$message({
                showClose: true,
                type: 'success',
                message: this.$t('message.saveSussess'),
              });
              //this.importDetail(res.data.data);
              this.returnPath();
            } else {
              if (this.sysConfigFlag == 'Y' && res.data.msg.indexOf('合同认领失败') > -1) {
                this.$repeatConfirm(
                  "<div><img src='/static/img/tips.png'/>" +
                    "<div class='repeatContent'>" +
                    res.data.msg +
                    '</div></div>',
                  '',
                  {
                    dangerouslyUseHTMLString: true,
                    confirmButtonText: this.$t('salePurchase.message.submitAgain'),
                    cancelButtonText: this.$t('confirm.cancel'),
                    center: true,
                    callback: async (action) => {
                      if (action === 'confirm') {
                        params.checkAmountFlag = 'Y';
                        let repeatRes = await this.$axios.post(API.SAVE_FUNDBILL, params);
                        if (repeatRes.data.code == 0) {
                          this.$message({
                            showClose: true,
                            type: 'success',
                            message: this.$t('message.saveSussess'),
                          });
                          this.returnPath();
                          //this.importDetail(repeatRes.data.data);
                        } else {
                          this.$message({
                            showClose: true,
                            type: 'error',
                            message: repeatRes.data.msg,
                          });
                        }
                      } else {
                        this.$message({
                          type: 'info',
                          message: this.$t('salePurchase.message.gitUpSubmitAgain'),
                        });
                      }
                    },
                  }
                );
              } else {
                this.$message({
                  showClose: true,
                  type: 'error',
                  message: res.data.msg,
                });
              }
            }
          }
        }
      },
      returnPath() {
        // 返回列表页
        let path = {
          fromPath: {
            path: this.$route.path,
            name: this.$route.name,
            meta: { keepAlive: true },
          },
          toPath: {
            path: '/capital/collectBillManage',
            name: 'collectBillManage',
            meta: { keepAlive: false },
          },
        };
        this.$store.dispatch('tagsView/backTabView', path).then(() => {
          this.$nextTick(() => {
            this.$router.push(path.toPath);
          });
        });
      },
      // handleUpload(uploadTableData) {
      //   // 附件上传
      //   this.fundAttachmentList = uploadTableData;
      // },
      tips(info, type) {
        // 提示
        this.$message({
          showClose: true,
          message: this.$t(`billDetail.message.${info}`),
          type: type,
        });
      },
    },
  };
</script>
